import React from 'react';
import PropTypes from 'prop-types';

import 'normalize.css';
import Header from './Header';
import Footer from './Footer';
import '../styles/master.scss';

import PortalContainer from '../utils/PortalContainer';

import { Helmet } from 'react-helmet';

const Layout = ({ children }) => {
  return (
    <PortalContainer>
        <Helmet>
          <link rel="preconnect" href="https://fonts.gstatic.com" />
          <link
            href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
            rel="stylesheet"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Domine:wght@600;700&display=swap"
            rel="stylesheet"
          />
          <link
            rel="stylesheet"
            type="text/css"
            charset="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
        </Helmet>
        <div className="mainscroll">
          <Header />
          <main>{children}</main>
          <Footer />
        </div>
    </PortalContainer>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
